import React from 'react'
import HTag from '@/lib/HTag'
import NewsListCTA from './NewsListCTA'
import { graphql, useStaticQuery, Link } from 'gatsby'
import NewsItem from './NewsItem'

const NewsList = ({ heading, cta, blockId }) => {
	const { newsItems } = useStaticQuery(query)

	return (
		<section id={blockId} className="bg-orange text-white text-center">
			<div className="section">
				<HTag className="h1 text-center" {...heading} />

				<div className="grid md:grid-cols-2 gap-8 items-start mt-8 text-grounding-navy">
					<div className="bg-white p-4">
						<ul>
							{newsItems.nodes?.map((news, key) => (
								<NewsItem {...news} key={key} />
							))}
						</ul>
						<p>
							<Link className="action" to="/blog?category=News">
								See latest Step Up News
							</Link>
						</p>
					</div>

					<NewsListCTA {...cta} />
				</div>
			</div>
		</section>
	)
}

export default NewsList

const query = graphql`query NewsList {
	newsItems: allSanityBlogPost(
		sort: {fields: publishDate, order: DESC}
		filter: {categories: {elemMatch: {name: {eq: "News"}}}}
		limit: 2
	) {
		nodes {
			title
			publishDate
			metaInfo { slug { current } }
		}
	}
}`
